import logo from "./images/logo.png";

const Logo = ({classes = ""}: {classes?: string}) => {
    return (
        <img className={classes} src={logo} alt="logo"/>
    )
};

export default Logo;